// U6's registrationsSelfService switch as the pages see it (infrastructure-
// specification, Feature switch). Read once when the app starts; off until
// read and off if it cannot be read, so the menu never offers My
// registrations or the registrant list the API would refuse.
import { createContext, useContext, useEffect, useState, type ReactNode } from 'react';
import { useApi } from './api-context';

const RegistrationsSwitchContext = createContext(false);

export function RegistrationsSwitchProvider(props: { children: ReactNode }) {
  const api = useApi();
  const [isOn, setIsOn] = useState(false);
  useEffect(() => {
    let isCurrent = true;
    api
      .get<{ registrationsSelfService?: unknown }>('/api/v1/public/features')
      .then((features) => {
        if (isCurrent) setIsOn(features.registrationsSelfService === true);
      })
      // Unreadable switches keep the screens hidden; nothing started fails.
      .catch(() => undefined);
    return () => {
      isCurrent = false;
    };
  }, [api]);
  return (
    <RegistrationsSwitchContext.Provider value={isOn}>
      {props.children}
    </RegistrationsSwitchContext.Provider>
  );
}

// A fixed switch, for tests and previews.
export function FixedRegistrationsSwitch(props: { isOn: boolean; children: ReactNode }) {
  return (
    <RegistrationsSwitchContext.Provider value={props.isOn}>
      {props.children}
    </RegistrationsSwitchContext.Provider>
  );
}

export const useIsRegistrationsOn = () => useContext(RegistrationsSwitchContext);
